// Dependencias generales
import React from "react";
import { useEffect } from 'react';

import FullDayForecasting from './FullDayForecasting'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateAEMETLocation = endpointHelias+'/3rdParty/V0/AEMET/updateAEMETLocation';	

var jsonObjWeekInfo = {"Forecasting":[]}

// Función del router
const WeekForecasting = (params) => {    

    useEffect(() => {                 
      console.log("Detalle forecasting semanal METEO cargado correctamente.")

      if ((jsonObjWeekInfo.Forecasting.length === 0) && (!document.getElementById("detallePrevision7Dias").className.includes("hidden")) ){
        cargarDatosAEMETSemana()
      }

    }, [params]);

    function cargarDatosAEMETSemana(){
      
        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

        document.getElementById("loaderSemana").className = document.getElementById("loaderSemana").className.replace(" hidden", "")

        var fechaActual = new Date();
        var añoActual = fechaActual.getFullYear();
        var mesActual = (fechaActual.getMonth()+1);
        var diaActual = fechaActual.getDate();
        var horaActual = fechaActual.getHours()
          
        if (mesActual < 10){ mesActual = "0"+mesActual;	}
        if (diaActual < 10){ diaActual = "0"+diaActual;	}
        if (horaActual < 10){ horaActual = "0"+horaActual; }
        
        var datetimePeticion = añoActual + "-" + mesActual + "-" + diaActual + "T" + horaActual + ":00:00"

        //Petición de datos para el paso actual
        var jsonPeticion = { "idMunicipio": params.municipalityId, "fechaHora": datetimePeticion, "numeroDias": "7" }

        // Guardo la información  
        var xhttp = new XMLHttpRequest();  
          xhttp.open("POST", updateAEMETLocation, true);        
          xhttp.setRequestHeader('Content-Type', "application/json");
          xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
          var data = JSON.stringify(jsonPeticion);
          xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
              var jsonRespuesta = JSON.parse(this.responseText)
      
              if(jsonRespuesta.statusCode === "403"){                   
                initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
              }
              else if(jsonRespuesta.statusCode === "500"){                   
                document.getElementById("divErrorPrevision").className = document.getElementById("divErrorPrevision").className.replaceAll(" hidden", "")
                document.getElementById("loaderSemana").className = document.getElementById("loaderSemana").className.replaceAll(" hidden", "") + " hidden"
              }
              else if(jsonRespuesta.statusCode === "200"){

                //Si recibo datos ya configurados lo cargo  

                if(typeof jsonRespuesta.body !== 'undefined'){  

                  jsonObjWeekInfo = jsonRespuesta.body   
                  
                  document.getElementById("loaderSemana").className = document.getElementById("loaderSemana").className.replaceAll(" hidden", "") + " hidden"
                  params.setObjWeekForecastUpdateTimestamp(new Date().getTime())

                  document.getElementById("divErrorPrevision").className = document.getElementById("divErrorPrevision").className.replaceAll(" hidden", "") + " hidden"

                  //Si no hay datos configurados entonces no hago nada  
                  console.log("Datos de la previsión AEMET semanal cargados correctamente.")

                }

              }
              else{
                document.getElementById("divErrorPrevision").className = document.getElementById("divErrorPrevision").className.replaceAll(" hidden", "")
                document.getElementById("loaderSemana").className = document.getElementById("loaderSemana").className.replaceAll(" hidden", "") + " hidden"
              }          
              
            }
      
            if (this.readyState === 4 && this.status !== 200) {      
              initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
            }
          }
          xhttp.send(data);    
          
    }

    const listWeekForecasting = jsonObjWeekInfo.Forecasting.map((day) =>

      <FullDayForecasting key={day.Datetime} objDayForecasting={day}/>

    );

      return (
        <>
        
        <div id="listadoFiltros" className="vertical">  

            <ul className="vertical gap-04" aria-label={typeof(jsonObjWeekInfo.AEMETUpdateTime) !== "undefined" ? "Pronóstico de las "+dashboardCommonJS.formatearAFechaHoraCorta(jsonObjWeekInfo.AEMETUpdateTime, "UTC") : ""}>

              {listWeekForecasting} 

            </ul>

            <div id="divErrorPrevision" className="message medium empty hidden">
              
              <section className="error-container">
                <div className="message warning huge">
                  <span className="material-icon">report</span> 
                  <h1 className="title">AEMET inoperativo</h1>
                  <p >Parece que los servidores de la Agencia Estatal de Meteorología están teniendo problemas. Inténtalo de nuevo más tarde.</p>
                </div>                
              </section>
                        
            </div>  

            <div id="loaderSemana" className="loader hidden">
              <progress aria-label={params.Mensaje} style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>          
            </div>          

        </div>
        
        </>
      )

}

export default WeekForecasting